import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface ISaveBeneficiaryRequest {
  accountName: string;
  accountNumber: string;
  bankCode: string;
  bankName: string;
  alias: string;
}

interface ISaveBeneficiaryResponse {
  status?: boolean;
  message?: string;
  data?: unknown;
  errors?: IApiResponseError[];
}

const initialState: IApiState<ISaveBeneficiaryResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const saveBeneficiaryAsync = createAsyncThunk(
  'beneficiary/save',
  async (
    values: ISaveBeneficiaryRequest,
    { rejectWithValue, dispatch, getState }
  ) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      };

      const { data } = await api.post('/beneficiaries', values, config);

      setTimeout(() => {
        window.location.reload();
      }, 2500);

      return data;
    } catch (err) {
      const error = err as AxiosError<ISaveBeneficiaryResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const beneficiaryCreationSlice = createSlice({
  name: 'beneficiary/save',
  initialState,
  reducers: {
    resetBeneficiaryCreation(state) {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveBeneficiaryAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(saveBeneficiaryAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as ISaveBeneficiaryResponse;
      })
      .addCase(saveBeneficiaryAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as ISaveBeneficiaryResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetBeneficiaryCreation } = beneficiaryCreationSlice.actions;

export default beneficiaryCreationSlice.reducer;
